let apiHost;
switch (process.env.REACT_APP_ENV) {
  case 'localdev':
    apiHost = 'http://localhost:8666';
    break;
  case 'production':
    apiHost = 'https://api.tempokit.com';
    break;
  default:
    apiHost = 'https://api-staging.tempokit.com';
}

// THESE ARE ALL PUBLIC visible, don't store private keys ever here.
const tempokitDevFirebase = {
  apiKey: 'AIzaSyBPsKmRFf4PtyiJ_5zLlvhPtfT2EjJ_3bo',
  authDomain: 'tempokit-dev.firebaseapp.com',
  databaseURL: 'https://tempokit-dev.firebaseio.com',
  projectId: 'tempokit-dev',
  storageBucket: 'tempokit-dev.appspot.com',
  messagingSenderId: '1079450036854',
  appId: '1:1079450036854:web:79ffbfac7ddc98f5dd8d57',
};
const tempokitProdFirebase = {
  apiKey: 'AIzaSyB8ibaEHGAVdOY_cBi22cSwUCyYGV4RHeI',
  authDomain: 'tempokit-a2581.firebaseapp.com',
  databaseURL: 'https://tempokit-a2581.firebaseio.com',
  projectId: 'tempokit-a2581',
  storageBucket: 'tempokit-a2581.appspot.com',
  messagingSenderId: '9604456000',
  appId: '1:9604456000:web:4519e4e442b4b4a8d109a5',
  measurementId: 'G-4CPV2YV02Z',
};

const config =
  process.env.REACT_APP_ENV === 'production'
    ? {
        stripePublicKey:
          'pk_live_51H3A0rH0lLqmXKcgkqzfi1mqZi9oFpeLZxKXkKcGlH1EN16igrKikPEI1jYJrBBL5fe1CO23AgYbT2d8YHjzNp4000hJmYBNrC',
        firebase: tempokitProdFirebase,
      }
    : {
        stripePublicKey:
          'pk_test_51H3A0rH0lLqmXKcgIo09XIkdzFpq405IewGr1JyTwqv42qDLTaD8tRxTZlw9IbgVN8VKVuX20swDIx9vwpU4h9kZ00oeXuaaJU',
        firebase: tempokitDevFirebase,
      };

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

export const firebaseConfig =
  process.env.REACT_APP_ENV === 'production'
    ? tempokitProdFirebase
    : tempokitDevFirebase;

export { apiHost, config as default };
